/**
 * Created by neo on 21.01.2026
 * Trackers Section - Contains fitness tracker connections
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { TrackerConnectionSection } from './TrackerConnectionSection';

const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const TrackersSection: React.FC = observer(() => {
  return (
    <SectionContent>
      <TrackerConnectionSection />
    </SectionContent>
  );
});
